import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Jumps to the top of the page — instantly, never animated.
//
// Bootstrap's CSS sets `scroll-behavior: smooth` on <html>, which turns a plain
// window.scrollTo(0, 0) into a slow slide from wherever the previous page was
// scrolled. Any scroll, touch or layout change during that slide stops it
// half-way, so a page like /booking-confirmation could open at the passenger
// section instead of the top. Switching the CSS off for this one call makes
// the jump instant in every browser (older ones ignore `behavior: "instant"`).
const jumpToTopInstantly = () => {
  const rootElement = document.documentElement;
  const previousScrollBehavior = rootElement.style.scrollBehavior;

  rootElement.style.scrollBehavior = "auto";
  // "instant" overrides the CSS in browsers that support it; the inline style
  // above covers the ones that don't.
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  rootElement.style.scrollBehavior = previousScrollBehavior;
};

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // useLayoutEffect (not useEffect) runs before the browser paints, so the new
  // page is never shown even for one frame at the old page's scroll position.
  useLayoutEffect(() => {
    jumpToTopInstantly();
  }, [pathname]);

  return null;
}
